import React, { useState } from 'react';
import { MailIcon, LinkedinIcon, FileTextIcon, PhoneIcon, XIcon } from 'lucide-react';
const MobileContactFAB = ({
  language = 'en'
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const contactActions = [{
    icon: MailIcon,
    label: 'Email',
    labelVi: 'Email',
    href: 'mailto:Nguyen.trung2@northeastern.edu',
    color: 'from-accent-cyan to-blue-500'
  }, {
    icon: LinkedinIcon,
    label: 'LinkedIn',
    labelVi: 'LinkedIn',
    href: 'https://www.linkedin.com/in/realtrungnguyen',
    color: 'from-blue-500 to-accent-violet'
  }, {
    icon: FileTextIcon,
    label: 'Resume',
    labelVi: 'Sơ yếu lý lịch',
    href: 'https://drive.google.com/file/d/1xwQiDuMCpDS251PZjFMsAYgSGDJ5PQiY/view?usp=sharing',
    color: 'from-accent-violet to-accent-amber'
  }, {
    icon: PhoneIcon,
    label: 'Phone',
    labelVi: 'Điện thoại',
    href: 'tel:+17746706733',
    color: 'from-accent-amber to-accent-cyan'
  }];
  return <div className="fixed bottom-6 right-6 z-[45] flex items-center" data-id="element-891">
      {/* Main FAB Button */}
      <button onClick={toggleMenu} className={`w-14 h-14 rounded-full bg-gradient-to-br from-accent-cyan to-accent-violet flex items-center justify-center text-white shadow-xl transform transition-all duration-300 hover:scale-110 active:scale-95 ${isOpen ? 'rotate-45' : 'rotate-0'}`} aria-label={isOpen ? 'Close contact menu' : 'Open contact menu'} data-id="element-892">
        {isOpen ? <XIcon size={24} className="transition-transform duration-300" data-id="element-893" /> : <MailIcon size={24} className="transition-transform duration-300" data-id="element-894" />}
      </button>

      {/* Contact Action Buttons - Expand to the LEFT */}
      <div className={`absolute right-16 flex gap-3 transition-all duration-300 ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'}`} data-id="element-895">
        {contactActions.map((action, index) => {
        const Icon = action.icon;
        return <a key={index} href={action.href} target={action.href.startsWith('http') ? '_blank' : undefined} rel={action.href.startsWith('http') ? 'noopener noreferrer' : undefined} className={`w-12 h-12 rounded-full bg-gradient-to-br ${action.color} flex items-center justify-center text-white shadow-lg transform transition-all duration-300 hover:scale-110 active:scale-95`} style={{
          transitionDelay: isOpen ? `${index * 50}ms` : '0ms',
          transform: isOpen ? 'scale(1) translateX(0)' : 'scale(0.8) translateX(20px)'
        }} onClick={() => setIsOpen(false)} data-id="element-896">
              <Icon size={20} data-id="element-897" />
            </a>;
      })}
      </div>

      {/* Backdrop */}
      {isOpen && <div className="fixed inset-0 bg-background/50 backdrop-blur-sm -z-10" onClick={() => setIsOpen(false)} data-id="element-898" />}
    </div>;
};
export default MobileContactFAB;